import { render } from "./Arena_Chat.vue?vue&type=template&id=6f9f6354&scoped=true"
import script from "./Arena_Chat.vue?vue&type=script&lang=js"
export * from "./Arena_Chat.vue?vue&type=script&lang=js"

import "./Arena_Chat.vue?vue&type=style&index=0&id=6f9f6354&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9f6354"]])

export default __exports__